import { render } from "./ActionEmail.vue?vue&type=template&id=e37ba3f2"
import script from "./ActionEmail.vue?vue&type=script&lang=js"
export * from "./ActionEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__